import { isValidPhoneNumber } from 'react-phone-number-input';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import isMissing from 'utils/predicates/any/isMissing.util';

export const isValidUrl = (u) => {
  try {
    new URL(u);
    return true;
  } catch {
    return false;
  }
};

export const isValidPhone = (options) => {
  const { defaultCountry, defaultCallingCode } = options ?? {};

  const text = fromAnyToString(options?.value);

  const result =
    isMissing(defaultCountry) && isMissing(defaultCallingCode)
      ? isValidPhoneNumber(text)
      : isValidPhoneNumber(text, { defaultCountry, defaultCallingCode });

  return fromAnyToBool(result);
};
